import {Injectable} from '@angular/core';
import {
    AbstractDataServiceDtoSummaryAdapter
} from '../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter';
import {Scan3dGroupSummaryModel} from '../../../api/entity/scan3dGroupSummary.model';
import {Scan3dGroupSummaryConverter} from '../../../api/entity/converter/scan3dGroupSummary.converter';
import {Scan3dGroupModel} from '../../../api/entity/scan3dGroup.model';
import {Scan3dGroupDataService} from './scan3dGroupData.service';

@Injectable()
export class Scan3dGroupSummaryDataServiceAdapter extends AbstractDataServiceDtoSummaryAdapter<
    Scan3dGroupSummaryModel, Scan3dGroupSummaryConverter, Scan3dGroupModel> {
    constructor(dataService: Scan3dGroupDataService, converter: Scan3dGroupSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): Scan3dGroupModel {
        return new Scan3dGroupModel();
    }
}
